<template>
    <div>
        <top-bar></top-bar>
        <div class="contain">
            <img src="@/assets/intro/main.jpg" />
            <div class="main-title">{{getLan('3ed325a7-75ce-4afe-b53d-518ac32be391')}}</div>
            <article class="main-content">
                <p>{{getLan('70d6ce71-ea92-40b8-9dea-7952b93e5dd9')}}</p>
                <p>{{getLan('f42cef07-3ac4-4f3f-a62e-2d44d56cc20f')}}</p>
                <p>{{getLan('8dd3126c-c946-4808-b5f0-7aa235d9435e')}}</p>
            </article>
        </div>
        <bottom-bar></bottom-bar>
    </div>
</template>

<script>
import TopBar from './TopBar'
import BottomBar from './BottomBar'
export default {
    components: {
        TopBar,
        BottomBar,
    },
    mounted() {
        if (this.$route.query.lan) {
            this.bus.nowLan = this.$route.query.lan
        }
    }
}
</script>

<style scoped>
.contain {
    padding: 3.25rem 24.08rem;
}

.contain img {
    width: 100%;
}
.main-title {
    margin-top: 2.46rem;
    margin-bottom: 1.62;
    font-size: 1.36rem;
    line-height: 1.8rem;
    color: #333;
}
.main-content {
    line-height: 1.88rem;
    color: #666;
    font-size: 1.05rem;
}
.main-content p {
    text-indent: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/Intro.vue